import axios from 'axios'
import store from '../store'

export default {      
    methods: {
        getCategories(){            
            ////console.log('Inicio getCategories');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.categories = true;   
                                    
            //this.axios.get(this.ApiBaseUrl + 'items/categorias/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)    
            this.axios.post(this.ApiBaseUrlNETCore + 'api/categorias','',{headers: {"Content-Type": "application/json"}})
            .then(response => {
                if (response.data == 'logout'){
                    this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                    store.commit("logout");
                }                                        
                /*for (var i = 0; i < response.data.length; i++){
                    response.data[i].allow = false;
                    response.data[i].active = false;
                }       */
                //Funcion recursiva para eliminar todas las keys subCategories que sean null. Requerido para el treeview
                function deletenullchildrens(node){
                    if (node.subCategories == null){
                        delete node.subCategories;
                    } else {
                        for (var i = 0; i<node.subCategories.length; i++){
                            deletenullchildrens(node.subCategories[i]);
                        }
                    }
                }
                if (store.state.menuitems[0].items.length != response.data.length){
                    for (var i = 0; i < response.data.length; i++){
                        deletenullchildrens(response.data[i]);
                    }
                    store.state.menuitems[0].items = response.data;
                } else {
                    for (var i = 0; i < response.data.length; i++){
                        response.data[i].allow = store.state.menuitems[0].items[i].allow;
                        response.data[i].active = store.state.menuitems[0].items[i].active;
                        deletenullchildrens(response.data[i]);
                    }
                    store.state.menuitems[0].items = response.data;
                }
                if (store.state.appconfig.promociones){
                    store.state.promocionesGrupos = [];
                    for (var i = 0; i < store.state.menuitems[0].items.length; i++){   
                        if (store.state.menuitems[0].items[i].subCategories){
                            for (var j = 0; j < store.state.menuitems[0].items[i].subCategories.length; j++){   
                                if (store.state.menuitems[0].items[i].subCategories[j].HasPromo){
                                    store.state.promocionesGrupos.push(store.state.menuitems[0].items[i].subCategories[j]);
                                }
                            }
                        }
                    }
                }
            })            
            .finally(function () {
                store.state.activeAxiosComms.categories = false;
                store.commit('hideGlobalLoader');                
            });
          },
        getRutas(){            
            ////console.log('Inicio getRutas');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.rutas = true;   
                                                
            this.axios.post(this.ApiBaseUrlNETCore + 'api/rutas',{salesperson: this.$store.state.usuario.vendedor},{headers: {"Content-Type": "application/json"}})
            .then(response => {
                if (response.data == 'logout'){
                    this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                    store.commit("logout");
                }                                        
                function getRandomColor() {
                    var letters = '0123456789ABCDEF';
                    var color = '#';
                    for (var i = 0; i < 6; i++) {
                        color += letters[Math.floor(Math.random() * 16)];
                    }
                    return color;
                }
                function hexToRgb(hex) {
                    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                    return result ? {
                      r: parseInt(result[1], 16),
                      g: parseInt(result[2], 16),
                      b: parseInt(result[3], 16)
                    } : null;
                  }
                var events = [];
                for (var i = 0; i < response.data.length; i++){
                    var color = getRandomColor();
                    var components = hexToRgb(color);
                    var textColor = "#fff";
                    if ((components.r*0.299 + components.g*0.587 + components.b*0.114) > 186) 
                        textColor =  "#000000";                    
                    var event = {
                        no: response.data[i].no,
                        title: response.data[i].decription,
                        details: response.data[i].decription,
                        date : response.data[i].date.substr(0,10),
                        customer: response.data[i].customerNo,  
                        customerName: response.data[i].customerName, 
                        style: "backgroundColor: " + color + ";border: 1px solid " + color + "; color: " + textColor,
                        backgroundColor: color,
                        textColor: textColor,
                        open: false
                    }
                    events.push(event);
                }
                //store.state.rutasEventos = events;  
                store.commit('setRutas',events); 
            })            
            .finally(function () {
                store.state.activeAxiosComms.rutas = false;
                store.commit('hideGlobalLoader');                
            });
          },
        visitaSinPedido(id){
            ////console.log('Inicio visitaSinPedido');
            store.commit('showGlobalLoader');            
            this.$store.state.activeAxiosComms.order = true;                                                   
            this.axios.post(this.ApiBaseUrlNETCore + 'api/Sales/closeTodo',{id: id},{headers: {"Content-Type": "application/json"}})
            .then(response => {        
                if (response.data){
                    this.getRutas();
                }
            })
            .finally(function () {
                store.state.activeAxiosComms.order = false;
                store.commit('hideGlobalLoader');
            });
        },
        getItems(openDialog){
            this.checkSession();
            //console.log('Inicio getItems');
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.items = true; 
            var filterVal = this.$store.state.filter;                       
            //if (filterVal == '') filterVal = '-1';
            /*var resCat = this.$store.state.menuitems[0].items.filter(cat=>{
                return cat.allow == true;
            });*/
            var thisaux = this;
            //Creacion de los filtros de categoria y subcategoria
            //var catFilter = '-1';
            //var subCatFilter = '-1';
            var catFilter = [];
            var subCatFilter = [];
            for (var i = 0; i < this.$store.state.menuitems[0].selectedItems.length; i++){
                var pos = this.$store.state.menuitems[0].selectedItems[i].indexOf("#$#");
                if (pos > -1){
                    subCatFilter.push(this.$store.state.menuitems[0].selectedItems[i].substr(pos+3));
                    if (!catFilter.find(cat => cat == this.$store.state.menuitems[0].selectedItems[i].substr(0,pos))){
                        catFilter.push(this.$store.state.menuitems[0].selectedItems[i].substr(0,pos));
                    }
                } else {
                    catFilter.push(this.$store.state.menuitems[0].selectedItems[i]);
                }
            }
            ////console.log(this.$store.state.axiosSource);
            if (this.$store.state.axiosSource != undefined){
                this.$store.state.axiosSource.cancel('Petición obsoleta');
                ////console.log('Peticion obsoleta');
            }            

            this.$store.state.axiosSource = this.axios.CancelToken.source(); 

            var locFilter = '';
            if (this.$store.state.tipoDocumento == 'disponible'){
                locFilter = this.$store.state.almacenDisponible;                
                if (!locFilter) locFilter = this.$store.state.usuario.locationCode;
            }
            var url = '';
            var custNo = 'x';
            //simplificar esto
            if (!this.$store.state.topventas){
                if (this.$store.state.usuario.type == 'CLIENTE') { 
                    //url = this.ApiBaseUrl + 'items/' + this.$store.state.orderbygroup + '/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + catFilter + '/' + subCatFilter + '/' + filterVal + '/20/' + this.$store.state.usuario.custNo + '/' + this.$store.state.onlyAvailable + '/' + this.$store.state.onlyPromos + '/' + locFilter;
                    custNo = this.$store.state.usuario.custNo;
                } else {                    
                    if (this.$store.state.selectedCustIndex > -1) custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;
                    //url = this.ApiBaseUrl + 'items/' + this.$store.state.orderbygroup + '/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + catFilter + '/' + subCatFilter + '/' + filterVal + '/20/' + custNo + '/' + this.$store.state.onlyAvailable + '/' + this.$store.state.onlyPromos + '/' + locFilter;
                }
            } else{        
                if (this.$store.state.usuario.type == 'CLIENTE')  {      
                    //url =  this.ApiBaseUrl + 'items/top/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo;
                    custNo = this.$store.state.usuario.custNo;
                } else {
                    //url =  this.ApiBaseUrl + 'items/top/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customers[this.$store.state.selectedCustIndex].No;
                    custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;
                }
            }
            url = this.ApiBaseUrlNETCore + "api/items";

            var enableCustGroups = false;
            var available = this.$store.state.onlyAvailable;
            if (this.$store.state.usuario.type == 'CLIENTE')  {      
                enableCustGroups = this.$store.state.appconfig.enableCustGroups;
                if (!available && (!this.$store.state.appconfig.showNoStockCust)){
                    available = true;
                }
            } else {
                if (!available && (!this.$store.state.appconfig.showNoStockSeller)){
                    available = true;
                }
            }

            
                                    
            ////console.log(url);
            //this.axios.get(url,{cancelToken: this.$store.state.axiosSource.token})
            this.axios.post(url,
                {
                    filter: filterVal,
                    catfilter: catFilter,
                    grpfilter: subCatFilter,
                    locfilter: locFilter,
                    disponible: this.$store.state.tipoDocumento == 'disponible' ? true : false,
                    top: this.$store.state.topventas,
                    user: this.$store.state.usuario.id,
                    userGUID: this.$store.state.usuario.userGUID,
                    cust: custNo,
                    orderByGrp: this.$store.state.orderbygroup,
                    onlyAvailable: available,
                    onlyPromos: this.$store.state.onlyPromos,
                    limit: this.$store.state.appconfig.topItems,
                    enableCustGroups: enableCustGroups,
                    showNoStockCust: this.$store.state.appconfig.showNoStockCust,
                    showNoStockSeller: this.$store.state.appconfig.showNoStockSeller
                },{cancelToken: this.$store.state.axiosSource.token})
            .then(response => {    
                try{                                             
                    if (response.data == 'logout'){
                        this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
                        store.commit("logout");
                    }
                    
                    if (response.data.length == undefined){
                        response.data = [response.data];
                    }                                       
                    /*if (this.$store.state.topventas){
                        var ordenados = [];
                        if (response.data.order != ''){
                            var orden = response.data.order.split('|');  
                            for (var i = 0; i < orden.length; i++){
                                var res = response.data.filter(itm =>{
                                    return itm.No == orden[i];
                                });
                                ordenados.push(res[0]);
                            }
                        }
                        response.data = ordenados;
                    }*/
                    var grupoTmp='x¬€¬x';          
                    for (var i = 0; i < response.data.length; i++){                    
                        //response.data[i].Picture = this.checkImg(response.data[i].Picture);                                        
                        //var res = this.menuitems[0].items.filter(menuitem =>{return menuitem.Code == response.data[i].Category});
                        //response.data[i].visible = res[0].allow;
                        
                        /*if (response.data[i].prices.length == undefined){
                            response.data[i].prices = [response.data[i].prices];
                        }*/
                        if (response.data[i].Picture != ''){
                            var pic = response.data[i].Picture;
                            response.data[i].Picture = this.PicturesURL + 'thumbnails_normal/' + pic;
                            response.data[i].PictureL = this.PicturesURL + 'thumbnails_large/' + pic;
                            response.data[i].PictureXL = this.PicturesURL + 'thumbnails_x-large/' + pic;
                        } else {
                            response.data[i].Picture = require('../assets/noimage.png');
                            response.data[i].PictureL = require('../assets/noimage.png');
                            response.data[i].PictureXL = require('../assets/noimage.png');
                        }
                        var res = this.$store.state.orderItems.filter(itm=>{
                            return itm.No == response.data[i].No;
                        });
                        response.data[i].isActive = false;
                        response.data[i].uom = response.data[i].baseUOM;
                        response.data[i].uoms =[{code: response.data[i].baseUOM, qty_per_uom: 1}];
                        response.data[i].qtyperuom = 1;
                        response.data[i].cantidad = 0;
                        if (res.length){
                            response.data[i].qtyperuom = res[0].qtyperuom;
                            response.data[i].uoms = res[0].uoms;
                            response.data[i].uom = res[0].uom;
                            response.data[i].descuento = parseFloat(res[0].descuento);
                            response.data[i].cantidad += parseFloat(res[0].cantidad);
                        }

                        /*if (response.data[i].descuentos.length == undefined){
                            response.data[i].descuentos = [response.data[i].descuentos];                            
                            if ((response.data[i].descuentos.length == 1) && (parseFloat(response.data[i].descuentos[0].Discount) == 0))
                                response.data[i].descuentos = [];                            
                        }
                        //Se quitan los desceuntos que no pertenezcan al cliente
                        for (var j = 0; j < response.data[i].descuentos.length; j++){                                                        
                            if ((response.data[i].descuentos[j].SalesTypeDesc == 'Customer') && (this.$store.state.usuario.type == 'CLIENTE')){                                                                
                                if ((response.data[i].descuentos[j].SalesCodeDesc != this.$store.state.usuario.custNo)){
                                    response.data[i].descuentos.splice(j,1);                                
                                    j--;
                                } 
                            } else if ((response.data[i].descuentos[j].SalesTypeDesc == '"Customer Disc. Group"') && (this.$store.state.usuario.type == 'CLIENTE')){
                                if ((response.data[i].descuentos[j].SalesCodeDesc != this.$store.state.usuario.discGroup)){
                                    response.data[i].descuentos.splice(j,1);                                
                                    j--;
                                }
                            } else if ((response.data[i].descuentos[j].Discount == '') || (parseFloat(response.data[i].descuentos[j].Discount) == 0)){
                                response.data[i].descuentos.splice(j,1);                                
                                j--;
                            }
                        }*/
                                            
                        response.data[i].visible = true;
                        response.data[i].item = true;                    
                        /*if ((this.$store.state.tipoDocumento != 'disponible') && (this.$store.state.tipoDocumento != 'transferencia')){    
                            if (this.$store.state.usuario.type == 'CLIENTE'){                            
                                var resprecios = response.data[i].prices.filter(price=>{ return price.Code == this.$store.state.usuario.custNo});
                                if (!resprecios.length){
                                    resprecios = response.data[i].prices.filter(price=>{ return price.Code == this.$store.state.usuario.salesGroup});
                                   
                                }
                            } else {
                                var resprecios = response.data[i].prices.filter(price=>{ return price.Code == this.$store.state.customers[this.$store.state.selectedCustIndex].No});
                                if (!resprecios.length){
                                    resprecios = response.data[i].prices.filter(price=>{ return price.Code == this.$store.state.customers[this.$store.state.selectedCustIndex].CustomerPriceGroup});
                                    
                                }
                            }        
                        }*/            
                        response.data[i].Disponible = parseFloat(response.data[i].Disponible).toFixed(2);
                        if (response.data[i].CustomerPrice != 0){
                            response.data[i].precio = response.data[i].CustomerPrice;
                            response.data[i].precioUnit = response.data[i].CustomerPriceUnit;
                            response.data[i].importeILT=response.data[i].CustomerPriceILT;
                        } else if (response.data[i].CustomerPriceGroupPrice != 0) {
                            response.data[i].precio = response.data[i].CustomerPriceGroupPrice;
                            response.data[i].precioUnit = response.data[i].CustomerPriceGroupPriceUnit;
                            response.data[i].importeILT=response.data[i].CustomerPriceGroupPriceILT;
                        } else if (response.data[i].AllCustomersPrice != 0) {
                            response.data[i].precio = response.data[i].AllCustomersPrice;
                            response.data[i].precioUnit = response.data[i].AllCustomersPriceUnit;
                            response.data[i].importeILT= response.data[i].AllCustomersPriceILT;
                        } else {
                            response.data[i].precio = 0;
                            response.data[i].precioUnit = 0;
                            response.data[i].importeILT= 0;
                        }

                        if (Number(response.data[i].precio)){
                            response.data[i].precio = response.data[i].precio.toFixed(2);
                        }
                                                                                                                     
                        if (response.data[i].lotes){
                            for (var j = 0; j < response.data[i].lotes.length; j++){
                                response.data[i].lotes[j].disponible = parseFloat(response.data[i].lotes[j].disponible);
                            }
                        }
                        if (this.$store.state.tipoDocumento != 'abono'){
                            if (response.data[i].lotes){
                                if  (response.data[i].lotes.length){
                                    response.data[i].lotes = response.data[i].lotes.filter(lote =>{
                                        return lote.disponible > 0;
                                    })
                                }
                            }
                        }
                        
                        /*if (response.data[i].uoms.length == undefined){
                            response.data[i].uoms = [response.data[i].uoms];
                        }*/

                        /*if (response.data[i].promos){
                            if (response.data[i].promos.length == undefined){
                                response.data[i].promos = [response.data[i].promos];
                                if ((response.data[i].promos.length == 1) && (response.data[i].promos[0].ItemNo == '')){
                                    response.data[i].promos = [];
                                }
                            }
                            
                            for (var j = 0; j<response.data[i].promos.length; j++){
                                response.data[i].promos[j].active = true;
                                response.data[i].promos[j].MinQty = parseFloat(response.data[i].promos[j].MinQty);
                                if (this.$store.state.usuario.type == 'CLIENTE'){                                   
                                    if ((response.data[i].promos[j].SalesType == 'Customer') && (response.data[i].promos[j].SalesCode != this.$store.state.usuario.custNo)){
                                        response.data[i].promos[j].active = false;
                                    }
                                }
                            }   
                        }             */        
                        
                        if ((this.$store.state.orderbygroup) && (response.data[i].Group != grupoTmp) && (!response.data[i].groupHeader)){
                            grupoTmp = response.data[i].Group;
                            var groupH = {
                                groupHeader: true,
                                groupName : (response.data[i].GroupName != '') ? response.data[i].GroupName : response.data[i].Group,
                                groupCode : response.data[i].Group
                            };                        
                            response.data.splice(i,0,groupH);                        
                            i++;
                        }
                        if ((response.data[i].ItemTrackingCode == 'SEGLOTE') || (response.data[i].ItemTrackingCode == 'SEGLOTECAD') || (response.data[i].ItemTrackingCode == 'LOTNSVENT')){
                            response.data[i].trackingEnabled = true;
                        } else {
                            response.data[i].trackingEnabled = false;
                        }
                    }                      
                    if ((response.data.length == 1) && (response.data[0].No == "")){
                        store.state.items = [];                        
                    } else           
                        store.state.items = response.data;   
                    if (store.state.appconfig.promociones){
                        store.state.promosDestacadas = [];
                        thisaux.getPromos(store.state.items);  
                    }                   
                    //thisaux.getUoms(store.state.items,0);
                    ////console.log(JSON.stringify(store.state.items));
                    store.state.activeAxiosComms.items = false; 
                    store.commit('hideGlobalLoader');
                    store.state.axiosSource = undefined; 
                    if (openDialog == true) this.openDialog(store.state.items[0]);
                } catch (e){
                    console.log(e);
                    store.state.items = [];
                }
            })
            .catch(thrown => {
                if (axios.isCancel(thrown)) {
                  //console.log(thrown.message);
                } else {
                    store.state.activeAxiosComms.items = false; 
                    store.commit('hideGlobalLoader');
                    store.state.axiosSource = undefined; 
                }
            })
            .finally(function () {
                                               
            });
        },
        getPromos(items){            
            var url = this.ApiBaseUrlNETCore + "api/promos";                                    
            //console.log(url);            
            var res = items.filter(item => {
                return (item.promoCode !=  null);
            });
            var ids = [];
            for(var i = 0; i<res.length; i++){
                ids.push(res[i].No);
            }
            if (ids.length > 0){            
                this.axios.post(url,{ids: ids})
                .then(response => {      
                    ////console.log(response);
                    for(var i = 0; i<response.data.length; i++){
                        var resItems = items.filter(item => {
                            return (item.No == response.data[i].ItemNo);
                        });
                        if (resItems[0].promos == null) resItems[0].promos = []
                        resItems[0].promos.push(response.data[i]);
                    }
                    store.commit('setItems',items);
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                         
                    //Se hace un resumen de las principales promociones en la seleccion de articulos actual
                    //La 3 primeras promocioes validas de 3 articulos
                    store.state.promosDestacadas = [];
                    var res = items.filter(item => {
                        return (item.promos !=  null);
                    });            
                    for(var i = 0; i<res.length; i++){                
                        for (var j = 0; j < res[i].promos.length; j++){     
                            //if (res[i].promos[j].active){
                                if (res[i].promos[j].ItemPromoPictureURL == ''){
                                    var file = require('../assets/noimage.png');
                                    res[i].promos[j].ItemPromoPictureURL = file; 
                                }
                                store.state.promosDestacadas.push(res[i].promos[j]);
                                break;
                            //}
                        }                
                        if (store.state.promosDestacadas.length == 3) break;
                    }                                        
                }); 
            }            
        },
        getUoms(item,openDialog,setOrder,forceinsert,forceupdate){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/uoms";                                    
            //console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{id: item.No})
                .then(response => {      
                    ////console.log(response);
                    item.uoms = response.data;
                    if ((response.data) && (response.data.length == 1)){
                        item.uom = response.data[0].code;
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                                                            
                    //store.commit('setItems',items);
                    //thisaux.getUoms(items,i+1);
                    if (openDialog){
                        thisaux.openDialog(item);
                    } else if (setOrder){
                        thisaux.setOrderItem(item,forceinsert,forceupdate);
                    }
                }); 
            //} 
        },     
        getUomsAndCheckPrice(item,forceinsert,forceupdate){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/uoms";                                    
            console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{id: item.No})
                .then(response => {      
                    //console.log(response);
                    item.uoms = response.data;
                    if ((response.data) && (response.data.length == 1)){
                        item.uom = response.data[0].code;
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);                 
                })
                .finally(function () {                                                                            
                    //store.commit('setItems',items);
                    //thisaux.getUoms(items,i+1);                    
                    thisaux.checkPriceAndCommitToCart(item,forceinsert,forceupdate);
                }); 
            //} 
        },   
        getLotesAbono(item,openDialog,setOrder,forceinsert,forceupdate){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/lotes";  
            var custNo = '';
            if (this.$store.state.usuario.type == 'CLIENTE') {                 
                custNo = this.$store.state.usuario.custNo;
            } else {                    
                if (this.$store.state.selectedCustIndex > -1) 
                    custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;    
            }                              
            //console.log(url);
            this.axios.post(url,{id: item.No, cust: custNo})
            .then(response => {      
                ////console.log(response);
                /*response.data.filter(lot =>{
                    return lot.qty > 0;
                })*/
                item.lotes = response.data;
                if ((response.data) && (response.data.length == 1)){
                    item.lote = response.data[0].code;
                }
                item.lotes.forEach(lot => {
                    lot.disponible = parseFloat(lot.disponible) * parseFloat(lot.qtypuom);
                });
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                                                
                if (openDialog){
                    thisaux.openDialogLote(item);
                } else if (setOrder){
                    thisaux.setOrderItem(item,forceinsert,forceupdate);
                }
            });
        },
        /*getCustomers(returnToMenu){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.customers = true;
            var filter =  this.$store.state.custFilter;
            if (filter == ''){
                //filter = '-1';                
                return;
            }
            //console.log(this.ApiBaseUrl + 'clientes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' +  filter + '/' + this.$store.state.usuario.vendedor);
            this.axios.get(this.ApiBaseUrl + 'clientes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' +  filter + '/' + this.$store.state.usuario.vendedor)
            .then(response => {       
                if (response.data.xml.cliente.length == undefined) 
                    response.data.xml.cliente = [response.data.xml.cliente]; 
                for (var i = 0; i < response.data.xml.cliente.length; i++){
                    if (response.data.xml.cliente[i].discounts.length == undefined)
                        response.data.xml.cliente[i].discounts = [response.data.xml.cliente[i].discounts];
                    //response.data.xml.cliente[i].discounts.discount = parseFloat(response.data.xml.cliente[i].discounts.discount.replace(/\./g,'').replace(',', '.'));
                    //response.data.xml.cliente[i].discounts.minAmount = parseFloat(response.data.xml.cliente[i].discounts.minAmount.replace(/\./g,'').replace(',', '.'));
                }
                store.state.customers = response.data.xml.cliente;  
                if (store.state.customers.length <= (store.state.selectedCustIndex)){
                    store.state.selectedCustIndex = 0;
                }
                if (returnToMenu){
                    this.$router.push('menu');
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
              })
            .finally(function () {
                store.state.activeAxiosComms.customers = false;
                store.commit('hideGlobalLoader');    
            });
        },*/
        getCustomers(returnToMenu){
            this.checkSession();
            store.commit('showGlobalLoader');
            //this.$store.state.activeAxiosComms.customers = true;
            store.commit('setCustomerLoading',true);
            var filter =  this.$store.state.custFilter;
            if (filter == ''){
                //filter = '-1';                
                return;
            }
            if (this.$store.state.axiosSourceCustomers != undefined){
                this.$store.state.axiosSourceCustomers.cancel('Petición obsoleta');
                //console.log('Peticion obsoleta');
            } 
            this.$store.state.axiosSourceCustomers = this.axios.CancelToken.source(); 
            //console.log(this.ApiBaseUrl + 'clientes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' +  filter + '/' + this.$store.state.usuario.vendedor);
            //this.axios.get(this.ApiBaseUrl + 'clientes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' +  filter + '/' + this.$store.state.usuario.vendedor)
            var url = this.ApiBaseUrlNETCore + 'api/cust/search';
            this.axios
            .post(url, 
                {filter : filter, salesperson : this.$store.state.usuario.vendedor, user: this.$store.state.usuario.id, guid: this.$store.state.usuario.userGUID, relationType: this.$store.state.appconfig.userCustomerRelationType},
                {cancelToken: this.$store.state.axiosSourceCustomers.token,headers: {"Content-Type": "application/json"}}) //API
            .then(response => {       
                /*if (response.data.xml.cliente.length == undefined) 
                    response.data.xml.cliente = [response.data.xml.cliente];                  
                store.state.customers = response.data.xml.cliente;*/
                store.state.customers = response.data;
                if (store.state.customers.length <= (store.state.selectedCustIndex)){
                    store.state.selectedCustIndex = 0;
                }
                if (returnToMenu){
                    this.$router.push('menu');
                }
                store.commit('setCustomerLoading',false);
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
                if (error.message != 'Peticion obsoleta')
                    store.commit('setCustomerLoading',false);
              })
            .finally(function () {
                store.state.axiosSourceCustomers = undefined;
                store.commit('hideGlobalLoader');    
            });
        },
        getInvoices(selected, ignoreCust, onlyPending){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;
            var fcd = '-1';
            var fch = '-1'; 
            var frd = '-1';
            var frh = '-1';
            if (this.$store.state.appconfig.filterInvoiceDocumentDate){
                fcd = this.formatDateSQL(this.fechas[0].date);
                fch = this.formatDateSQL(this.fechas[1].date);                
                frd = this.formatDateSQL(this.fechas[2].date);
                frh = this.formatDateSQL(this.fechas[3].date);                
            } else {
                frd = this.formatDateSQL(this.fechas[0].date);
                frh = this.formatDateSQL(this.fechas[1].date);    
                var datediffms = Date.parse(this.fechas[1].date) - Date.parse(this.fechas[0].date);
                var datediffdays = Math.floor(datediffms / 86400000);
                if (!ignoreCust){
                    if (datediffdays > 365){
                        this.setGlobalDialog('Rango máximo excedido','Máximo 1 año, acote la búsqueda.', false);
                        store.commit('hideGlobalLoader');   
                        return;
                    }
                } else {
                    if (datediffdays > 7){
                        this.setGlobalDialog('Rango máximo excedido','Máximo 7 días, acote la búsqueda.', false);
                        store.commit('hideGlobalLoader');   
                        return;
                    }
                }            
            }
                            
        
            /*var url = this.ApiBaseUrl + '/pedidos/facturaspdtes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customers[this.$store.state.selectedCustIndex].No + '/' +
                      fcd + '/' + fch + '/' + frd + '/' + frh + '/nan/nan';
                      //console.log(url);*/
            var url = this.ApiBaseUrlNETCore + "api/Documents"; 
            var custNo;
            if (ignoreCust){
                custNo = '';
            } else {
                if (this.$store.state.usuario.type == 'COMERCIAL')
                    custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No
                else 
                    custNo = this.$store.state.usuario.custNo;
            }
            this.axios.post(url,{filtroCliente: custNo,
                fechaCreaDesde : fcd,
                fechaCreaHasta : fch,
                fechaRegistroDesde : frd,
                fechaRegistroHasta : frh,
                cabeceras : true,
                filtroDocumento : "",
                salesperson: this.$store.state.usuario.vendedor,
                filtroTipoDocumento : selected,
                soloPendientes: onlyPending})
            //this.axios.get(url)
            .then(response => {
                if (response.data.length == undefined)
                    response.data = [response.data]                    
                store.state.facturas = response.data;
                for (var i = 0; i < store.state.facturas.length; i++){
                    store.state.facturas[i].selected = false;
                    store.state.facturas[i].mail = false;
                    if (store.state.facturas[i].numero == ''){                        
                        store.state.facturas.splice(i,1);
                    }
                }
                if (store.state.facturas.length == 0) store.state.facturas = [];
                //console.log(store.state.facturas);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        getInvoice(docNo){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;
            var fcd = '-1';
            var fch = '-1'; 
            var frd = '-1';
            var frh = '-1';                                                
            /*var url = this.ApiBaseUrl + '/pedidos/facturaspdtes/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customers[this.$store.state.selectedCustIndex].No + '/' +
                      fcd + '/' + fch + '/' + frd + '/' + frh + '/nan/nan';
                      //console.log(url);*/
            var url = this.ApiBaseUrlNETCore + "api/Documents";   
            var custNo;
            if (this.$store.state.usuario.type == 'COMERCIAL')
                custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No
            else 
                custNo = this.$store.state.usuario.custNo;    
            if (docNo != '') custNo = '';
            this.axios.post(url,{filtroCliente: custNo,
                fechaCreaDesde : fcd,
                fechaCreaHasta : fch,
                fechaRegistroDesde : frd,
                fechaRegistroHasta : frh,
                salesperson: '',
                cabeceras : false,
                filtroDocumento : docNo,
                filtroTipoDocumento : []})
            //this.axios.get(url)
            .then(response => {
                if (response.data.length == undefined)
                    response.data = [response.data]                    
                store.state.facturaActual = response.data;
                for (var i = 0; i < store.state.facturaActual.length; i++){                    
                    if (store.state.facturaActual[i].numero == ''){                        
                        store.state.facturaActual.splice(i,1);
                    }
                }
                if (store.state.facturaActual.length == 0) store.state.facturaActual = [];
                //console.log(store.state.facturaActual);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        GetAvailable(itemno){
            var thisaux = this;
            this.$store.commit("setAvailable",[]);
            console.log(JSON.stringify(itemno));
            this.axios.post(this.ApiBaseUrlNETCore + 'api/items/ItemAvail',JSON.stringify(itemno),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                //this.Available = JSON.parse(response.data.body.res)
                
                var avail = JSON.parse(response.data.return_value);
                avail.forEach(av => {
                    av.QtyAvailable = parseFloat(av.QtyAvailable);
                    av.PurchLinesQty = parseFloat(av.PurchLinesQty);
                    //av.QtyAvailable = av.QtyAvailable - av.PurchLinesQty;
                });
                avail = avail.filter(av => {
                    return (av.QtyAvailable != 0) || (av.PurchLinesQty != 0);
                }); 
                //console.log(avail);
                thisaux.$store.commit("setAvailable",avail);
            })
        },
        sendDocument(docNo,docType,email){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.invoices = true;            
            var url = this.ApiBaseUrlNETCore + "api/MailingDocuments";   
            switch(docType){
                case 'PEDIDO':
                    docType = 0;
                    break;
                case 'Factura':
                    docType = 1;
                    break;
                case 'Factura Alb.':
                    docType = 2;
                    break;
                case 'Abono':
                    docType = 3;
                    break;
            }
            this.axios.post(url,{docNo: docNo,
                docType : docType,
                email : email})
            //this.axios.get(url)
            .then(response => {
                //console.log(response);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.invoices = false; 
                store.commit('hideGlobalLoader');             
            });

        },
        anulaFactura(){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.anularFactura = true;
            var url = '';
            this.axios.get(url)
            .then(response => {               
                //console.log(response);
            })
            .catch(function (error) {
                
                // handle error
                //console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.anularFactura = false; 
                store.commit('hideGlobalLoader');             
            });
        },
        cobraFactura(documentNo){
            store.commit('showGlobalLoader');
            this.$store.state.activeAxiosComms.cobrarFactura = true;
            //var url = this.ApiBaseUrl + '/pedidos/lineacobro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.tipoCobro + '/' + documentNo + '/' + this.$store.state.numCheque;
            //this.axios.get(url)
            var url = this.ApiBaseUrlNETCore + "api/documents/lineacobro/";
            this.axios
            .post(url, {user: this.$store.state.usuario.id, guid: this.$store.state.usuario.userGUID, tipo: this.$store.state.tipoCobro, factura: documentNo, cheque: this.$store.state.numCheque },{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {                
                console.log(response);
            })
            .catch(function (error) {
                
                // handle error
                console.log(error);
            })
            .finally(function () {   
                store.state.activeAxiosComms.cobrarFactura = false; 
                store.commit('hideGlobalLoader');         
                this.getInvoices();    
            });
        },
        createNewCust(){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/cust/create";                                    
            //console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{
                    name: this.$store.state.newCustData.name,
                    alias: this.$store.state.newCustData.searchName,
                    cif: this.$store.state.newCustData.cif,
                    salesperson: this.$store.state.usuario.vendedor
                })
                .then(response => {      
                    //console.log(response);
                    if (response.status == 200){
                        thisaux.setGlobalDialogNewCust('Cliente ' + response.data,
                                                    'Creado nuevo cliente satisfactoriamente',false,response.data);
                        this.$store.state.newCustData.name = '';
                        this.$store.state.newCustData.searchName = '';
                        this.$store.state.newCustData.cif = '';
                    } else {
                        thisaux.setGlobalDialog('Error ',
                                                response.data,false);
                    }
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                                                            
                    //store.commit('setItems',items);
                    //thisaux.getUoms(items,i+1);

                }); 
            //} 
        },   
        sendOrderMail(orderNo){    
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/Sales/SendOrderMail";                                    
            //console.log(url);        
            //if (i < items.length){
                //var item = items[i];
                this.axios.post(url,{
                    no: orderNo
                })
                .then(response => {      
                    //console.log(response);
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);                 
                })
                .finally(function () {                                                                            
                }); 
            //} 
        },  
        saveOrder(){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/items/saveOrder";
            //console.log(url);        
            this.axios.post(url,{orderJson: JSON.stringify(this.$store.state.orderItems), user: this.$store.state.usuario.id})
            .then(response => {      
                ////console.log(response);
                
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
                store.commit('hideGlobalLoader'); 
                store.commit('resetOrderItems'); 
                store.commit('endLoading');   
            }); 
        },
        clearStoredOrder(){
            var thisaux = this;        
            var url = this.ApiBaseUrlNETCore + "api/items/saveOrder";
            //console.log(url);        
            this.axios.post(url,{orderJson: '', user: this.$store.state.usuario.id})
            .then(response => {      
                ////console.log(response);
                
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                 
            })
            .finally(function () {                                                                            
                store.commit('hideGlobalLoader'); 
                store.commit('resetOrderItems'); 
                store.commit('endLoading');   
            }); 
        },
        createOrder(cobrar,shipToAddress){          
            //console.log('Inicio createOrder');  
            try{
                store.commit('showGlobalLoader');
                this.$store.state.activeAxiosComms.order = true; 
                var now = new Date();
                var fechaRegistro = '';
                var abono =  0;
                if (this.$store.state.tipoDocumento == 'abono')
                    abono = 1;
                if ((now.getMonth() + 1) < 10) fechaRegistro += '0' + (now.getMonth() + 1);
                else fechaRegistro += now.getMonth() + 1;
                if ((now.getDate()) < 10) fechaRegistro += '0' + now.getDate();
                else fechaRegistro += now.getDate();
                fechaRegistro+= now.getFullYear();

                var salesperson = '';
                if (this.$store.state.usuario.type == 'COMERCIAL'){
                    salesperson = this.$store.state.usuario.vendedor;
                }
                var url = '';
                if (abono) url = this.ApiBaseUrlNETCore + 'api/Sales/CreateSalesCreditMemo';
                else url = this.ApiBaseUrlNETCore + 'api/Sales/CreateSalesOrder';
                var salesHeader = { 
                    OrderNo: "",
                    CustNo: "",
                    user: "",
                    abono: false,
                    idEvento: '',
                    nota: this.$store.state.notaPedido,
                    notaRepartidor: this.$store.state.notaRepartidor,
                    salesperson : salesperson,
                    SalesLines: []
                };
                if (!abono) salesHeader.shipToAddress = shipToAddress;
                
                salesHeader.user = this.$store.state.usuario.id;
                salesHeader.abono = abono;
                salesHeader.idEvento = this.$store.state.idEvento;
                var salesLines = [];
                for (var i = 0; i < this.$store.state.orderItems.length; i++){
                    if (!this.$store.state.orderItems[i].isPromo) {
                        var line = {
                            itemno: '',
                            qty: 0,
                            location: '',
                            uom: '',
                            price: 0,
                            dto: 0
                        }
                        var lote = null;
                        var expDate = new Date();
                        if ((this.$store.state.tipoDocumento == 'abono') && (this.$store.state.orderItems[i].lotes)){
                            lote = this.$store.state.orderItems[i].lote;
                            lote.forEach(lot => {
                                var loteInfo = this.$store.state.orderItems[i].lotes.find(itm =>{
                                    return itm.lote == lot.lote;
                                });
                                if (loteInfo){
                                    lot.expDate = loteInfo.caducidad;
                                } else {
                                    lot.expDate = expDate;
                                }
                            });
                        }
                        line.itemno = this.$store.state.orderItems[i].No;
                        line.qty = this.$store.state.orderItems[i].cantidad;
                        line.uom = this.$store.state.orderItems[i].uom;
                        line.price = this.$store.state.orderItems[i].precio;
                        line.dto = this.$store.state.orderItems[i].descuento;
                        line.lote = lote;                    

                        salesLines.push(line);
                    }
                }
                salesHeader.SalesLines = salesLines;

                if (this.$store.state.usuario.type == 'CLIENTE'){
                    salesHeader.CustNo = this.$store.state.usuario.custNo;
                } else {
                    salesHeader.CustNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;
                }
                var thisAux = this;
                this.axios.post(url,salesHeader)
                .then(response => {
                    //this.createOrderLine(response.data,0,cobrar);
                    if (response.status == 200){
                        if ((store.state.appconfig.autoventa) && (store.state.tipoDocumento == 'autoventa')){
                            this.autoventapost(response.data.message,cobrar,false);
                            store.commit('resetOrderItems');
                            store.commit('endLoading'); 
                        } else if ((store.state.appconfig.autoventa) && (store.state.tipoDocumento == 'abono')){
                            this.autoventapost(response.data.message,cobrar,true);
                            store.commit('resetOrderItems');
                            store.commit('endLoading'); 
                        } else {       
                            store.commit('hideGlobalLoader'); 
                            store.commit('resetOrderItems'); 
                            store.commit('endLoading');                                 
                            store.state.tipoDocumento = '';
                            //this.navigate(1);
                            /*if (abono){
                                this.setGlobalDialog(this.getDocTitle() + ' creado','Se ha creado el ' + this.getDocTitle().toLowerCase()  + ' nº ' + response.data.SalesCreditMemoPage.No + ' en el sistema',true);
                            } else {
                                this.setGlobalDialog(this.getDocTitle() + ' creado','Se ha creado el ' + this.getDocTitle().toLowerCase()  + ' nº ' + response.data.SalesOrderPage.No + ' en el sistema',true);
                            }*/
                            this.clearStoredOrder();
                            this.setGlobalDialog(this.getDocTitle() + ' creado','Se ha creado el ' + this.getDocTitle().toLowerCase()  + ' nº ' + response.data.message + ' en el sistema',true);
                            if (this.$store.state.usuario.type == 'CLIENTE'){
                                this.sendOrderMail(response.data.message);
                            }
                        }
                    } else {
                        this.setGlobalDialog('Error', response.data.message,false);
                    }
                })
                .catch(function (error) {
                    store.commit('hideGlobalLoader'); 
                    store.commit('endLoading');  
                    thisAux.setGlobalDialog('Error',error.response.data.message,false);
                    // handle error
                    //console.log(error);
                })
                .finally(function () {   
                    store.state.activeAxiosComms.order = false; 
                    store.commit('hideGlobalLoader');
                    store.commit('endLoading');
                });
            } catch(e){
                this.setGlobalDialog('Error',e.message,false);
                store.commit('endLoading');
            }
        },
        /*
        createOrderLine(orderNo,i,cobrar){ 
            //console.log('Inicio createOrderLine ' + i);             
            store.commit('showGlobalLoader');                
            this.$store.state.activeAxiosComms.orderLine = true;
            var abono =  0;
            if (this.$store.state.tipoDocumento == 'abono')
                abono = 1;            
            if (i < this.$store.state.orderItems.length){   
                if (this.$store.state.orderItems[i].isPromo) {
                    this.createOrderLine(orderNo,i+1,cobrar);
                    return;
                }                             
                var lote = this.$store.state.orderItems[i].lote;
                if ((lote == undefined) || (lote == null) || (lote =='')){
                    lote = '-1';
                }
                var precio = this.$store.state.orderItems[i].precio;
                if (!this.$store.state.usuario.editPrices)
                precio = '-1';
                //console.log(this.ApiBaseUrl + 'pedidos/nuevo/linea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/' + this.$store.state.orderItems[i].No + '/' + this.$store.state.orderItems[i].uom + '/' + this.$store.state.orderItems[i].cantidad + '/' + this.$store.state.orderItems[i].descuento + '/' + abono + '/' + lote + '/' + precio);
                this.axios.get(this.ApiBaseUrl + 'pedidos/nuevo/linea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/' + this.$store.state.orderItems[i].No + '/' + this.$store.state.orderItems[i].uom + '/' + this.$store.state.orderItems[i].cantidad + '/' + this.$store.state.orderItems[i].descuento + '/' + abono + '/' + lote + '/' + precio)
                .then(response => {
                    this.createOrderLine(orderNo,i+1,cobrar);
                })
                .catch(function (error) {
                    // handle error
                    //console.log(error);
                    store.commit('hideGlobalLoader');    
                  })
                .finally(function () {
                    store.state.activeAxiosComms.orderLine = false;
                });
            } else {                   
                               
                if ((store.state.appconfig.autoventa) && (store.state.tipoDocumento == 'autoventa')){
                    this.autoventapost(orderNo,cobrar,false);
                    store.commit('resetOrderItems');
                    store.commit('flipLoading'); 
                } else if (store.state.tipoDocumento == 'abono'){
                    this.autoventapost(orderNo,cobrar,true);
                    store.commit('resetOrderItems');
                    store.commit('flipLoading'); 
                } else {       
                    store.commit('hideGlobalLoader'); 
                    store.commit('resetOrderItems'); 
                    store.commit('flipLoading');                                 
                    store.state.tipoDocumento = '';
                    //this.navigate(1);
                    this.setGlobalDialog(this.getDocTitle() + ' creado','Se ha creado el ' + this.getDocTitle().toLowerCase()  + ' nº ' + orderNo + ' en el sistema',true);
                }
            }            
        }, */       
        autoventapost(orderNo,cobrar,abono){
            var factAuto = (this.$store.state.customers[this.$store.state.selectedCustIndex].CombineShipments == 'No') ? false : true;
            if (factAuto){
                cobrar = false;
            }
            this.$store.state.activeAxiosComms.posting = true;
            var url = '';
            if (abono)
                //url = this.ApiBaseUrl + 'pedidos/registro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/1';
                url = this.ApiBaseUrlNETCore + "api/Sales/SalesPostMemo";
            else
                //url = this.ApiBaseUrl + 'pedidos/registro/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + orderNo + '/0';
                url = this.ApiBaseUrlNETCore + "api/Sales/SalesPost";
            //this.axios.get(url)
            this.axios.post(url,orderNo)
            .then(response => {
                var capitalDocStr = '';
                var docStr = '';
                var postedDocStr  = '';
                var docType = '';
                if ((!abono) && (!factAuto)) {
                    docStr = 'pedido';
                    postedDocStr = 'factura';
                    docType = 'FRA';
                    capitalDocStr = 'Pedido';
                } else if ((!abono) && (factAuto)){
                    docStr = 'pedido';
                    postedDocStr = 'albarán';
                    docType = 'ALB';
                    capitalDocStr = 'Pedido';
                } else if ((abono) && (!factAuto)){
                    docStr = 'abono';
                    postedDocStr = 'abono registrado';
                    docType = 'ABO';
                    capitalDocStr = 'Abono';
                } else if ((abono) && (factAuto)){
                    docStr = 'abono';
                    postedDocStr = 'recepción';
                    docType = 'RCP';
                    capitalDocStr = 'Abono';
                }                
                store.state.tipoDocumento = '';
                //this.navigate(1);
                if ((response.data.return_value == 'Nada que registrar') || (response.data.return_value == undefined))
                    this.setGlobalDialog('Error al registrar','Se ha creado el ' + docStr + ' nº ' + orderNo + ' en el sistema pero no ha sido posible registrarlo. Contacte con administración',true);
                else{
                    this.setGlobalDialogPrint(capitalDocStr + ' creado','Se ha creado el ' + docStr + ' nº ' + orderNo + ' en el sistema, ' + postedDocStr + ' nº ' + response.data.return_value,true,response.data.return_value,docType);
                    if (cobrar) this.lanzaDialogCobro(response.data.return_value);
                }
            })
            .catch(function (error) {
                // handle error
                //console.log(error);
                store.commit('hideGlobalLoader');    
              })
            .finally(function () {
                store.state.activeAxiosComms.posting = false;
            });
        },
        /*checkPriceAndCommitToCart(item,forceinsert,forceupdate){
            var auxstore = this.$store;
            var thisaux = this;
            var url = '';
            var price = 0;
            if (item.precioEditado)
                price = item.precio;            
            if ((item.descuento == undefined) || (item.descuento == ''))
                item.descuento = 0;

            if (this.$store.state.usuario.type == 'CLIENTE')  
                url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo + '/' + item.No + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
            else
                url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customers[this.$store.state.selectedCustIndex].No + '/' + item.No + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
            //console.log(url);
            this.$store.commit("setIsCheckingPrice",true);
            this.axios.get(url)
            .then(response => {
                //console.log(response);
                if (response.status == 200){
                    var json = JSON.parse(response.data.res);
                    item.precio = parseFloat(json.unitprice.replace(',',''));
                    item.descuento = parseFloat(json.linedisc);
                }
                //this.$store.commit('setOrderItem', item);                                   
            })
            .catch(function (error) {                
                // handle error
                //console.log(error);
                store.commit("setIsCheckingPrice",false);
              })
            .finally(function () {   
                store.commit("setIsCheckingPrice",false);
                thisaux.setOrderItem(item, forceinsert,forceupdate);                                           
            });
        },*/
        checkPriceAndCommitToCart(item,forceinsert,forceupdate){
            var auxstore = this.$store;
            var thisaux = this;
            var url = '';
            var price = 0;
            if (item.precioEditado)
                price = item.precio;            
            if (item.descuento == undefined)
                item.descuento = 0;

            if (item.uoms == null){
                this.getUomsAndCheckPrice(item,forceinsert,forceupdate);            
            } else { 
                url = this.ApiBaseUrlNETCore + "api/documents/detalleLinea/";
                var req = {};
                if (this.$store.state.usuario.type == 'CLIENTE')  
                    //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo + '/' + item.No + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                    req = { user:  this.$store.state.usuario.id,
                        guid: this.$store.state.usuario.userGUID,
                        custNo: this.$store.state.usuario.custNo,
                        itemNo: item.No,
                        uom: item.uom,
                        Qty: item.cantidad,
                        unitprice: price,
                        linedisc: item.descuento
                    }
                else
                    //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customers[this.$store.state.selectedCustIndex].No + '/' + item.No + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                    req = { user:  this.$store.state.usuario.id,
                        guid: this.$store.state.usuario.userGUID,
                        custNo: this.$store.state.customers[this.$store.state.selectedCustIndex].No,
                        itemNo: item.No,
                        uom: item.uom,
                        Qty: item.cantidad,
                        unitprice: price,
                        linedisc: item.descuento
                    }
                this.$store.commit("setIsCheckingPrice",true);
                this.axios.post(url, req,{headers: {"Content-Type": "application/json"}}) //API
                //this.axios.get(url)
                .then(response => {
                    //console.log(response);
                    if (response.status == 200){
                        var json = JSON.parse(response.data.res);
                        item.precio = parseFloat(json.unitprice.replace(',',''));
                        item.descuento = parseFloat(json.linedisc);
                    }
                    //this.$store.commit('setOrderItem', item);                                   
                })
                .catch(function (error) {                
                    // handle error
                    //console.log(error);
                    store.commit("setIsCheckingPrice",false);
                })
                .finally(function () {   
                    store.commit("setIsCheckingPrice",false);
                    thisaux.setOrderItem(item, forceinsert,forceupdate);                                           
                });
            }
        },
        commitToCart(item,forceinsert,forceupdate){
            if ((item.descuento == undefined) || (item.descuento == ''))
                item.descuento = 0;
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {
                    //Copiamos el objeto para no alterar sus datos aparte de la cantidad
                    var commitItem =  Object.assign({}, item);
                    if (this.$store.state.tipoDocumento == 'autoventa'){
                        if (commitItem.Disponible <= 0){
                            this.setGlobalDialog('Sin diponibilidad','No hay existencias del producto ' + commitItem.No,false);
                            this.getItems();
                            return;
                        }
                        if ((commitItem.Disponible - commitItem.cantidad) <= 0){
                            this.setGlobalDialog('Exceso de cantidad','Se ha introducido mayor cantidad (' + commitItem.cantidad + ') que la disponible para el producto ' + commitItem.No + ' (' + commitItem.Disponible + ')',false);
                            this.getItems();
                            return;
                        }                
                    }
                    /*
                    if ((commitItem.precio == 0) && (commitItem.descuento != 100)){
                        this.setGlobalDialog('Linea sin precio','No se ha introducido precio para el producto ' + commitItem.No ,false);
                        this.getItems();
                        return;
                    }*/
                this.checkPriceAndCommitToCart(commitItem,forceinsert,forceupdate); 
                }           
            })
        },
        getAppConfig(){
            //console.log('Inicio getAppConfig');
            /*this.axios.get(this.ApiBaseUrl + 'appconfig')
            .then(response => {          
                this.$store.state.appconfig.appname1 = response.data.xml.config.name;
                this.$store.state.appconfig.appname2 = response.data.xml.config.name2;
                this.$store.state.appconfig.defaultOrderType = response.data.xml.config.defaultOrderType.toLowerCase();                            
                if (response.data.xml.config.showLineCategories != 'No')
                  this.$store.state.appconfig.showLineCategories = true;
                else
                  this.$store.state.appconfig.showLineCategories = false;

                if (response.data.xml.config.autoventa != 'No')
                  this.$store.state.appconfig.autoventa = true;
                else
                  this.$store.state.appconfig.autoventa = false;

                if (response.data.xml.config.showAppSufix != 'No')            
                  this.$store.state.appconfig.showAppSufix = true;
                else
                  this.$store.state.appconfig.showAppSufix = false;

                if (response.data.xml.config.showItemPhoto != 'No')            
                  this.$store.state.appconfig.showItemPhoto = true;
                else
                  this.$store.state.appconfig.showItemPhoto = false;
                
                if (response.data.xml.config.filterInvoiceDocumentDate != 'No')            
                  this.$store.state.appconfig.filterInvoiceDocumentDate = true;
                else
                  this.$store.state.appconfig.filterInvoiceDocumentDate = false;

                if (response.data.xml.config.allowUOMS != 'No')            
                  this.$store.state.appconfig.allowUOMS = true;
                else
                  this.$store.state.appconfig.allowUOMS = false;

                if (response.data.xml.config.showVAT != 'No')            
                  this.$store.state.appconfig.showVAT = true;
                else
                  this.$store.state.appconfig.showVAT = false;

                if (response.data.xml.config.promociones != 'No')            
                  this.$store.state.appconfig.promociones = true;
                else
                  this.$store.state.appconfig.promociones = false;

                if (response.data.xml.config.enableCustGroups != 'No')            
                  this.$store.state.appconfig.enableCustGroups = true;
                else
                  this.$store.state.appconfig.enableCustGroups = false;                  
                this.$store.state.appconfig.version = response.data.xml.config.version;
                this.$store.state.appconfig.revision = response.data.xml.config.revision;
                this.$store.state.appconfig.servicesLanguage = response.data.xml.config.servicesLanguage;   
                if ((response.data.xml.config.topItems != 0) && (response.data.xml.config.topItems != undefined)){
                    this.$store.state.appconfig.topItems = response.data.xml.config.topItems;
                }
                if (response.data.xml.config.showNoStockCust != 'No')            
                  this.$store.state.appconfig.showNoStockCust = true;
                else
                  this.$store.state.appconfig.showNoStockCust = false;  
                if (response.data.xml.config.showNoStockSeller != 'No')            
                  this.$store.state.appconfig.showNoStockSeller = true;
                else
                  this.$store.state.appconfig.showNoStockSeller = false;  
                if (response.data.xml.config.showLogoImg != 'No')            
                  this.$store.state.appconfig.showLogoImg = true;
                else
                  this.$store.state.appconfig.showLogoImg = false;  
                  if (response.data.xml.config.tracking != 'No')            
                  this.$store.state.appconfig.tracking = true;
                else
                  this.$store.state.appconfig.tracking = false;  
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
              })
            .finally(function () {                
            });*/
            var url = this.ApiBaseUrlNETCore + "api/config/getConfig";
           this.axios
           .post(url,{},{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {
                var config = response.data[0];
                switch(config.defaultOrderType){
                    case 0:
                        config.defaultOrderType = '';
                        break;
                    case 1:
                        config.defaultOrderType = 'preventa';
                        break;
                    case 2:
                        config.defaultOrderType = 'autoventa';
                        break;
                    case 3:
                        config.defaultOrderType = 'abono';
                        break;
                }
                switch(config.NAVversion){
                    case 0:
                        config.NAVversion = 2013;
                        break;
                    case 1:
                        config.NAVversion = 2015;
                        break;
                    case 2:
                        config.NAVversion = 2017;
                        break;
                    case 3:
                        config.NAVversion = 2018;
                        break;
                    case 4:
                        config.NAVversion = 2019;
                        break;
                }
                switch(config.NAVrevision){
                    case 0:
                        config.NAVrevision = '';
                        break;
                    case 1:
                        config.NAVrevision = 'R2';
                        break;
                }
                switch(config.servicesLanguage){
                    case 0:
                        config.servicesLanguage = '';
                        break;
                    case 1:
                        config.servicesLanguage = 'es';
                        break;
                    case 2:
                        config.servicesLanguage = 'en';
                        break;
                }
                config.showNoStockSeller = true;
                config.showNoStockCust = true;
                this.$store.state.appconfig = config;
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                
              })
            .finally(function () {                
            });
        },
        checkSession(){
            if (this.$store.state.usuarioLogeado){
                var url = this.ApiBaseUrlNETCore + "api/login/checkSession/";
                this.axios.post(url, {user : this.$store.state.usuario.id , guid : this.$store.state.usuario.userGUID },{headers: {"Content-Type": "application/json"}}) //API
                //this.axios.get(this.ApiBaseUrl + 'checkUserGUID/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)
                .then(response => {          
                    //console.log(response);   
                    if (!response.data){
                        this.$store.state.dialogPayment = false;
                        this.$store.state.dialogComercial = false;

                        this.setGlobalDialog('Sesión de usuario invalidada','Ha sido devuelto a la pagina de acceso, acceda de nuevo',false);
                        store.commit("logout");
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);                
                })
                .finally(function () {                
                });
            }
        },
        getLiqReport(){
            //console.log('Inicio getLiqReport');
            this.axios.get(this.ApiBaseUrl + 'informeliquidacioncomerciales/' + this.$store.state.usuario.id + '/' + this.$store.state.tipoInforme + '/')
            .then(response => {                          
                  //console.log(response);
                  //console.log(window.location.pathname);                  
                  window.open(this.PrintDocsFolder + response.data.return_value); 
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
              })
            .finally(function () {                
            });
        },
        checkImg(url){
            this.axios.get(url)
            .then(response => {     
                return url;
            })
            .catch(error => {                
                return '';
            });            
        },
        getSalesPrice(item){
            
        },
        setOrderItem(item,forceinsert,forceupdate){         
            //console.log(store.state.orderItems);       
            item.qtyperuom = 1;
                        
            if (item.uoms == null){
                this.getUoms(item,false,true,forceinsert,forceupdate);            
            } else {                                                
                var res = item.uoms.filter(uom => {
                    return uom.code == item.uom;
                });
                if (res.length){
                    item.qtyperuom = parseFloat(res[0].qty_per_uom);
                }
                if (item.qtyperuom == NaN) item.qtyperuom = 1;

                var resListItems = store.state.items.find(itm => itm.No == item.No);
                if (resListItems){
                    resListItems.uom = item.uom;
                    resListItems.qtyperuom = item.qtyperuom;
                }

                if (item.isPromo == undefined) item.isPromo = false; 
                var res = [];                    
                if (forceupdate){
                    res = store.state.orderItems.filter(itm=>{
                        return (itm.No == item.No);
                    });
                } else {
                    res = store.state.orderItems.filter(itm=>{
                        return (itm.No == item.No) && (itm.lote == item.lote) && (itm.precio == item.precio) && (itm.descuento == item.descuento);
                    });
                }
                if (res.length && !forceinsert){
                    if (item.cantidad != 0){
                        res[0].qtyperuom = item.qtyperuom;
                        res[0].uom = item.uom;
                        //if (store.state.usuario.type == 'CLIENTE')
                            res[0].cantidad = item.cantidad;                            
                        //else
                            //res[0].cantidad = parseFloat(res[0].cantidad) + parseFloat(item.cantidad); 
                        res[0].descuento = item.descuento; 
                    } else {
                        //Si se cambia la cantidad a 0, que se elimine el producto de la lista
                        var index = store.state.orderItems.indexOf(res[0]);
                        store.state.orderItems.splice(index,1);
                    }
                } else {
                    if (item.cantidad != 0) store.state.orderItems.push(item);
                }
                if (this.$store.state.appconfig.promociones) this.checkItemPromo(item);
                this.$store.commit('setOrderItems', store.state.orderItems);
            }
        },
        checkItemPromo(item){
            var customerNo = '';
            if (this.$store.state.usuario.type == 'CLIENTE') 
                customerNo =  this.$store.state.usuario.custNo;
            else
                customerNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;

            var promos = item.promos;
            if (promos != undefined){
                if (promos.length == undefined) promos = [promos];
                for (var j = 0; j < promos.length; j++){
                    if (promos[j].ItemNo != ''){
                        if ((promos[j].SalesType == 'Customer') && (promos[j].SalesCode != customerNo)) continue;                    
                        var a;
                        if ((Number(item.cantidad) * Number(item.qtyperuom)) >= 0)
                            a = Math.floor(Number(item.cantidad) * Number(item.qtyperuom));
                        else 
                            a = Math.ceil(Number(item.cantidad) * Number(item.qtyperuom));
                        var b = Number(promos[j].MinQty);
                        if (b != 0){
                            var divInt = a / b;
                            divInt = Math.floor(divInt);
                        } else if(b == 0)   {
                            divInt = 1;
                        }
                        if (divInt != 0){
                            if (divInt >= 1){
                                var itemPromo = new Object;
                                itemPromo.isPromo = true;
                                itemPromo.No = promos[j].ItemPromo;
                                itemPromo.Description = promos[j].PromoCode;
                                itemPromo.uom = promos[j].uom;
                                itemPromo.descuento = 100;
                                itemPromo.precio = 0;
                                itemPromo.prodPostingGroup = 0;
                                itemPromo.cantidad = Number(promos[j].PromoQty)*divInt;
                                this.setOrderItem(itemPromo,true);
                                //var cantidad = checkAvail(promos[j].PromoCode,Number(promos[j].PromoQty)*divInt,Number(promos[j].PromoAvail,null));
                                //addUpdateLine(promos[j].ItemPromo, promos[j].PromoCode + ' - ' + promos[j].ItemPromoName, cantidad, 100, 0, Number(promos[j].PromoAvail), null, null, true);	
                            }
                        }
                        if ((promos[j].SalesType == 'Customer') && (promos[j].SalesCode == customerNo)) break;
                    }
                }
            }
        },
        openDialog(item){    
            //if (item.uoms == null){
            /*if ((item.uoms == null)){
                this.getUoms(item,true,false,false);
            } else {*/
                if ((item.trackingEnabled) || (this.$store.state.tipoDocumento == 'abono')){
                    this.openDialogLote(item);
                    return;
                }            
                /*this.sameNoItems = [];      
                this.sameNoItemsBackup = [];  */
                this.sameNoItems = this.$store.state.orderItems.filter(itm=>{
                    return itm.No == item.No;
                });          
                this.sameNoItems.forEach(sameNoItm => {
                    sameNoItm.uoms = item.uoms;
                });
                //Deep copy
                this.sameNoItemsBackup = JSON.parse(JSON.stringify(this.sameNoItems));
                this.dialogData.code = item.No;
                this.dialogData.title = item.Description;
                this.dialogData.picture = item.PictureXL;
                this.dialogData.pictureLazy = item.Picture;
    
                this.editedIndex = this.items.indexOf(item);
                this.editedItems = [];
                this.editedItems.push(Object.assign({}, item));
                if (this.$store.state.usuario.type == "COMERCIAL"){
                    this.editedItems[0].cantidad = 0;
                } else {
                    this.editedItems[0].cantidad = item.cantidad;
                    this.editedItems[0].uom = item.uom;
                }
                this.GetAvailable(item.No);
                this.dialog = true;
            //}
        },
        openDialogLote(item){    
            if (item.lotes == null) {
                this.getLotesAbono(item,true,false,false);
            } else {
                this.sameNoItems = this.$store.state.orderItems.filter(itm=>{
                    return itm.No == item.No;
                });          
                //Deep copy
                this.sameNoItemsBackup = JSON.parse(JSON.stringify(this.sameNoItems));
                //if (this.sameNoItemsBackup.length == undefined) this.sameNoItemsBackup = [this.sameNoItemsBackup];
                this.dialogData.code = item.No;
                this.dialogData.title = item.Description;
                this.dialogData.picture = item.PictureXL;
                this.dialogData.pictureLazy = item.Picture;
                
                this.editedIndex = this.items.indexOf(item);
                this.editedItems = [];
                this.editedItems.push(Object.assign({}, item));
                if (this.$store.state.usuario.type == "COMERCIAL"){
                    this.editedItems[0].cantidad = 0;
                    this.editedItems[0].lote = '';
                } else {
                    this.editedItems[0].cantidad = item.cantidad;
                    this.editedItems[0].uom = item.uom;
                    this.editedItems[0].lote = item.lote;
                }
                this.GetAvailable(item.No);
                this.dialog = true;
            }
        },
        openPromoDialog(promo){
            var res = this.items.filter(item =>{
                return item.No == promo.ItemNo;
            });
            if (res.length){
                this.openDialog(res[0]);
            }
        },
        navigate(id){      
            if (id == 4){
                window.open(
                    'http://192.168.1.15:8085/appventas/vue2.html',
                    '_blank' // <- This is what makes it open in a new window.
                );
                return;
            }        
            var res = this.navMenu.filter(menuitem =>{ return menuitem.id == id});                        
            res[0].color = this.$store.state.colorselected;
            var res = this.navMenu.filter(menuitem =>{ return menuitem.id != id});
            for (var i = 0; i < res.length; i++){
                res[i].color = store.state.colornoselected;
            }
            switch(id){
                case 1:
                    this.$router.push('menu');  
                    break;
                case 2:
                    this.$router.push('pedido');
                    break;
                case 3:
                    this.$router.push('facturas');  
                    break;
            }
        },
        lastOrder(checkCart, docType, docNo){
            var url = this.ApiBaseUrlNETCore + "api/sales/getLastLines/";
            var custNo = '';
            if (this.$store.state.usuario.type == 'Cliente'){
                custNo = this.$store.state.usuario.custNo;
            } else {
                custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;
            } 
            var thisaux = this;
            if (docType == undefined) docType = "Factura Alb.";
            if (docNo == undefined) docNo = "";
            var incompleteFlag = false;
            store.commit('showGlobalLoader');
            this.axios.post(url, {custNo : custNo , docType : docType, docNo : docNo, guid : this.$store.state.usuario.userGUID },{headers: {"Content-Type": "application/json"}}) //API
            //this.axios.get(this.ApiBaseUrl + 'checkUserGUID/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)
            .then(response => {
                //console.log(response);   
                if ((this.$store.state.orderItems.length > 0) && (response.data.length > 0) && checkCart){
                    this.$store.state.dialogLastOrder = true;
                    this.$store.state.dialogLastOrderData = {
                        docType: docType,
                        docNo:docNo
                    };
                    return;
                }
                var items = [];
                //response.data.forEach(shipmentLine => {
                var j = 0;
                for (var i = 0; i < response.data.length; i++){
                    
                    var shipmentLine = response.data[i];
                    var checkurl = this.ApiBaseUrlNETCore + "api/items";
                    var enableCustGroups = false;
                    if (this.$store.state.usuario.type == 'Cliente')  {      
                        enableCustGroups = this.$store.state.appconfig.enableCustGroups;
                    }
                    thisaux.axios.post(checkurl,
                        {
                            filter: shipmentLine.itemno,
                            catfilter: '',
                            grpfilter: '',
                            locfilter: '',
                            disponible: false,
                            top: false,
                            user: thisaux.$store.state.usuario.id,
                            userGUID: thisaux.$store.state.usuario.userGUID,
                            cust: custNo,
                            orderByGrp: false,
                            onlyAvailable: true,
                            onlyPromos: false,
                            limit: 1,
                            enableCustGroups: enableCustGroups
                        },{cancelToken: undefined})
                    .then(responseCheck => {   
                        var shipmentLineLocal  = response.data[j];
                        
                        if (responseCheck.data.length == 0){
                            incompleteFlag = true;
                        } else {
                            var item = {
                                No : shipmentLineLocal.itemno,
                                uoms : null,
                                cantidad : shipmentLineLocal.qty,
                                descuento : shipmentLineLocal.dto,
                                uom : shipmentLineLocal.uom,
                                uom_NAV : shipmentLineLocal.uom,
                                precio : shipmentLineLocal.price,
                                prodPostingGroup : shipmentLineLocal.vatpercent,
                                description : shipmentLineLocal.description,
                                promoCode : shipmentLineLocal.promoCode,
                                item : true
                            }
                            thisaux.checkPriceAndCommitToCart(item,false,false);
                            //items.push(item);
                        }
                        if (j == response.data.length-1){
                            thisaux.getPromosRedoOrder(items);
                            if (docType == 'Abono'){
                                thisaux.$store.commit('setTipoDocumento','abono');
                            }
                            thisaux.navigate(2);
                            if (incompleteFlag){
                                thisaux.setGlobalDialog('Recuperación de pedido incompleta','No se han podido recuperar todas las lineas del pedido',false);
                            }
                        }
                        j++;
                    });
                    
                };
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
            })
            .finally(function () {  
                store.commit('hideGlobalLoader');              
            });
        },
        custBalance(){
            var url = this.ApiBaseUrlNETCore + "api/cust/custBalance/";
            var custNo = '';
            if (this.$route.name == 'controldocumentos')
                custNo = this.$store.state.tempCust.no;
            else
                custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].No;
            this.axios.post(url, {no : custNo },{headers: {"Content-Type": "application/json"}}) //API
            //this.axios.get(this.ApiBaseUrl + 'checkUserGUID/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID)
            .then(response => {          
                console.log(response);   
                var result = response.data;
                if (this.$route.name == 'controldocumentos'){
                    this.$store.state.tempCust.balance = result.balance;
                    this.$store.state.tempCust.credito = result.credito;
                } else {
                    this.$store.state.customers[this.$store.state.selectedCustIndex].balance = result.balance;
                    this.$store.state.customers[this.$store.state.selectedCustIndex].credito = result.credito;
                    this.$store.commit('setSelectedCust',this.$store.state.selectedCustIndex);
                }
                this.$store.state.dialogCustInfo = true;
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
            })
            .finally(function () {                
            });
        },
        setEventDialog(title, msg, event){
            store.state.calEventDialogData.titulo = title;
            store.state.calEventDialogData.contenido = msg;
            store.state.calEventDialogData.event = event;
            store.state.calEventDialog = true;
        },
        setGlobalDialog(title, msg, returnMenu){
            store.state.globalDialogData.titulo = title;
            store.state.globalDialogData.contenido = msg;            
            store.state.globalDialogData.returnMenu = returnMenu;
            store.state.globalDialog = true;
        },
        setGlobalConfirmDialog(title, msg, returnMenu){
            store.state.globalConfirmDialogData.titulo = title;
            store.state.globalConfirmDialogData.contenido = msg;            
            store.state.globalConfirmDialogData.returnMenu = returnMenu;
            store.state.globalConfirmDialog = true;
        },
        setGlobalDialogPrint(title, msg, returnMenu, docNo, docType){
            store.state.globalDialogData.titulo = title;
            store.state.globalDialogData.contenido = msg;            
            store.state.globalDialogData.returnMenu = returnMenu;
            store.state.printhref = 'intent://factura/#Intent;scheme=autoventa;package=autoventa.print;S.doctype=' + docType + ';S.docno=' + docNo + ';S.browser_fallback_url=http%3A%2F%2Faliosoluciones.com;end'
            store.state.globalDialog = true;                        
        },
        setGlobalDialogNewCust(title, msg, returnMenu, nCustNo){
            store.state.globalDialogData.titulo = title;
            store.state.globalDialogData.contenido = msg;            
            store.state.globalDialogData.returnMenu = returnMenu;
            store.state.newCustNo = nCustNo;
            store.state.globalDialog = true;
        },
        getDocTitle(){
            switch(store.state.tipoDocumento){            
                case 'preventa':
                    return 'Pedido';
                case 'abono':
                    return 'Abono';  
                case 'autoventa':
                    return 'Pedido autoventa';
                default:
                    return 'Pedido';
            }
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatDateNAV (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}${month}${year}`
        },
        formatDateSQL (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}-${day}-${month}`
        },
        parseDate (date) {
          if (!date) return null
  
          const [day, month, year] = date.split('/')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        lanzaDialogCobro(documentNo){
            store.state.documentNos = [];
            if (documentNo != ''){
                store.state.documentNos.push(documentNo);
                store.state.dialogTipoCobro = true;
            } else {
                var res = store.state.facturas.filter(inv =>{
                    return inv.selected == true;
                });
                for(var i = 0; i < res.length; i++){
                    store.state.documentNos.push(res[i].DocumentNo);
                }
                store.state.dialogTipoCobro = true;
            }            
        },
        
        /**
         * Ajuste decimal de un número.
         *
         * @param {String}  tipo  El tipo de ajuste.
         * @param {Number}  valor El numero.
         * @param {Integer} exp   El exponente (el logaritmo 10 del ajuste base).
         * @returns {Number} El valor ajustado.
         */
        decimalAdjust(type, value, exp) {
            // Si el exp no está definido o es cero...
            if (typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
            }
            value = +value;
            exp = +exp;
            // Si el valor no es un número o el exp no es un entero...
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
            }
            // Shift
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            // Shift back
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }
        /*
        // Decimal round
        if (!Math.round10) {
            Math.round10 = function(value, exp) {
            return decimalAdjust('round', value, exp);
            };
        }
        // Decimal floor
        if (!Math.floor10) {
            Math.floor10 = function(value, exp) {
            return decimalAdjust('floor', value, exp);
            };
        }
        // Decimal ceil
        if (!Math.ceil10) {
            Math.ceil10 = function(value, exp) {
            return decimalAdjust('ceil', value, exp);
            };
        }*/
        
    },
    computed: {              
        navMenu:{
            get() {
                return this.$store.state.navMenu;
            },
            set(value){
                this.$store.commit('setNavMenu', value)
            }
        },
        isCheckingPrice:{
            get() {
                return this.$store.state.isCheckingPrice;
            }
        }
    }
}